<template>
  <section role="complementary" :class="{large : large}">
    <div class="image col-xs-2">
      <slot name="image"></slot>
    </div>
    <div class="content col-xs-10">
      <slot name="content"></slot>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    large: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
section {
  background: $colour-nhs-pale-grey;
  box-sizing: border-box;
  margin: 10px 0;
  padding: 0;
  display: flex;
  align-items: center;

  h1 {
    font-size: 1rem;
    transition: all ease-in-out 0.2s;
  }

  .image {
    padding-left: 0;
    align-self: flex-end;
  }

  .content {
    padding: 20px;
    box-sizing: border-box;
    strong {
      color: $colour-cactus-core-green;
    }

    p {
      line-height: 1.5;
    }
  }

  &.large {
    h1 {
      font-size: 1.75rem;
    }
  }
}
</style>
